export const environment = {
  municipio: '',
  production: true,
  isETopocartDev: false,
  isETopocartProd: false,
  isTopocart: false,
  isTopocartDev: false,
  isPortoVelho: false,
  isAlexania: false,
  isNext: true,
  isManaus: false,

  googleMapsKey: 'AIzaSyDa_RGUAd9-34P9bgA4181u_TPurVM-5FE',
  googleMapsAPI: 'https://maps.googleapis.com/maps/api/',
  /* Para ambientes onPremise é necessário a modificação da chave
  do reCAPTCHA, acesse https://www.google.com/recaptcha/admin
  com uma conta do dominio @topocart.com.br e crie uma chave para o dominio
do tipo v2/checkbox  que sera realizado o deploy */
  captchaKey: '6LfWRYYqAAAAAErbBilG1MiAS0rlsJ0paIp1el4f',
  googleGeoCodeAPI: 'https://maps.googleapis.com/maps/api/geocode/json',
  reportsUrl: 'https://relatorios.geo360.dev/',
  reportUrl: 'https://relatorios.geo360.dev/',

  visualizador360BaseUrl: 'https://visualizador360.geo360.dev',
  apiUrl: 'https://plataforma.geo360.dev/',
  conversorUrl: 'https://conversor.geo360.dev/',
  apiDjangoUrl: 'https://plataforma.geo360.dev/django/',
  apiUrlPostgrest: `https://gateway-geo360.dev/rest`,
  apiUrlGenericPostgrest: `https://gateway-geo360.dev/plataforma/rest`,
  apiUrlGenericPGTiles: `https://gateway.geo360.dev/plataforma/tiles/`,
  apiUrlPGTiles: `https://gateway-geo360.dev/tiles/`,
  apiDjangoDirectUrl: 'https://cadastro.geo360.dev/',
  djangoDirectUrlToken: 'Bearer 54d1a258-cce2-4e77-afbc-5bd350c55465',
  apiAttributesTable: 'https://tabela-atributos.geo360.dev/',
  postgRestUrl: 'https://gateway-geo360.dev/rest',
  pgtilesUrl: 'https://gateway-geo360.dev/tiles/',
  caracterizacaoUrl: 'https://caracterizacao.geo360.dev',
  reportV2Url: 'https://relatorios-v2.geo360.dev/',

  openRestUrl: 'https://openrest.desenvolvimento.geo360.topocart.dev.br/',


  apiCNAE: 'https://cnae.criciuma.apps.etopocart.com/',

  // apiUrl: 'https://api4.appsgeo.io/' /* API Oficial */,
  geoServerUrl: 'https://mapsrv2.appsgeo.io/geoserver/',
  // apiUrl: 'https://staging-api.appsgeo.io/' /* API Staging */,
  geoServerWFSUrl:
    'https://mapsrv2.appsgeo.io/geoserver/wfs' /* GeoServer WFS */,
  photonApi: 'https://photon.komoot.de/api/' /* Photon API */,
  firebase: {
    apiKey: 'AIzaSyD4riPTBVU39qjL336AjXfdroCJwNUwQvg',
    authDomain: 'appsgeo-test.firebaseapp.com',
    databaseURL: 'https://appsgeo-test.firebaseio.com',
    projectId: 'appsgeo-test',
    storageBucket: 'appsgeo-test.appspot.com',
    messagingSenderId: '358703366933',
    appId: '1:358703366933:apps:27b8be17ee90f30ba35f1c',
  },
  recaptchaKey: '6LcvkeAUAAAAAHy5Kofj78q5mntZFwHwL98KBFGI',
  mapboxToken:
    'pk.eyJ1Ijoidm0ybWFwYm94IiwiYSI6ImNrbTF6MTYzczB6aGYybnIzcDY0eW9vb2sifQ.J9ErWF5EO5w3oLqGjzqi_w',
  apiGatewayUrl: 'https://api-gateway.geo360.com.br/',
};
